import { render, staticRenderFns } from "./view-detail.vue?vue&type=template&id=8a7e1af0&scoped=true&"
import script from "./view-detail.vue?vue&type=script&lang=js&"
export * from "./view-detail.vue?vue&type=script&lang=js&"
import style0 from "./view-detail.vue?vue&type=style&index=0&id=8a7e1af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7e1af0",
  null
  
)

export default component.exports